import script from "./SectionTripleTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionTripleTitle.vue?vue&type=script&setup=true&lang=js"

import "./SectionTripleTitle.vue?vue&type=style&index=0&id=771bd600&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-771bd600"]])

export default __exports__